// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1oExY","label":"Section_label__1DfDh","contentWrap":"Section_contentWrap__1JmQS","footer":"Section_footer__2vUMM","footerInner":"Section_footerInner__3dtK5"};